import api from '../index';

const SHORTLIST_BODY = {include: 'campaign.brand_campaign_summary'};

const proposalUpdaters = {
  accept: async ({paidGigId}: {paidGigId: string}) => {
    return api.put(`/proposals/${paidGigId}/accept`, null);
  },
  addToShortlist: async ({paidGigId}: {paidGigId: string}) => {
    // SHORTLIST_BODY must be passed as data (not null) so jsonapi-react
    // invokes customSerializer; a null data arg short-circuits serialization
    // and sends an empty body.
    return api.put(`/proposals/${paidGigId}/add_to_shortlist`, SHORTLIST_BODY, {
      customSerializer: () => SHORTLIST_BODY,
    });
  },
  removeFromShortlist: async ({paidGigId}: {paidGigId: string}) => {
    return api.put(
      `/proposals/${paidGigId}/remove_from_shortlist`,
      SHORTLIST_BODY,
      {customSerializer: () => SHORTLIST_BODY}
    );
  },
  reject: async ({paidGigId}: {paidGigId: string}) => {
    return api.put(`/proposals/${paidGigId}/reject`, null);
  },
  extendExpirationDate: async ({paidGigId}: {paidGigId: string}) => {
    return api.put(`/proposals/${paidGigId}/extend_expiration_date`, null);
  },
  batch: async ({
    action,
    paidGigIds,
  }: {
    action: 'accept' | 'reject';
    paidGigIds: string[];
  }) => {
    const proposalRefs = paidGigIds.map((id) => ({type: 'proposals', id}));
    const body = {
      data: {
        type: 'batches',
        attributes: {action},
        relationships: {
          proposals: {
            data: proposalRefs,
          },
        },
      },
      included: proposalRefs,
    };
    return api.post('/proposals/batch', body, {
      customSerializer: () => body,
    });
  },
};

export default proposalUpdaters;
